import React from "react";
import OwlCarousel from "react-owl-carousel";
/// import { NavLink } from "react-router-dom";
import BlogHomebox from "./BlogHomebox";
import Aboutsection from "./Aboutsection";
import Howitwork from "./Howitwork";
import VideoForm from "./VideoForm";
import DataContent from "./DataContent";
import Servicedata from "./Servicedata";
import MetaData from "./MetaData";
import Clientdata from "./Clientdata";
import WhyChoosedata from "./WhyChoosedata";
import useWebsiteSetting, { useBannerdata, useContentdata ,useBlogs} from "../FetchAPI";


export default function Home() {

  const [bannerdata] = useBannerdata();
  const [webSetting] = useWebsiteSetting();
  const [contentdata] = useContentdata();

  const [Blogs] = useBlogs();

  const options = {
    loop: true,
    margin: 30,
    responsiveClass: true,
    nav: false,
    dots: false,
    autoplay: true,
    navText: ["&lt;", ">"],
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      700: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };


  return (
    <>
      <MetaData />

      {/* Slider Area */}
      <section className="home-slider">
        <OwlCarousel className="owl-theme" {...options}>
          <div className="item">
            <img
              src={bannerdata?.home_slider1}
              alt={bannerdata?.home_slider1_alt}
              title={bannerdata?.home_slider1_title}
            />
          </div>
          <div className="item">
            <img
              src={bannerdata?.home_slider2}
              alt={bannerdata?.home_slider2_alt}
              title={bannerdata?.home_slider2_title}
            />
          </div>
        </OwlCarousel>
      </section>
      {/* End Slider Area */}


      {/* About us  Area Start */}
      <Aboutsection />
      {/* About us  Area End */}

      <VideoForm
        IframeVideo={webSetting.iframe_video}
        SectionTitle={webSetting.video_form_title}
      />



      {/* Content-1 Section Start */}
      {contentdata.title1 && (
        <DataContent
          title={contentdata.title1}
          desc={contentdata.description1}
          img={'../../image/iconimg/images.png'}
          imgside={'right'}
          dnone={'No'}
        />
      )}

  {/* Services Section Start */}
    <Servicedata/>
  {/* Services Section End */}

     {/* Content-2 Section Start */}
      {contentdata.title2 && (
        <DataContent
          title={contentdata.title2}
          desc={contentdata.description2}
          img={'../../image/iconimg/content2.png'}
          imgside={'left'}
          dnone={'No'}
        />
      )}
      {/* Content-2 Section End */}

<Howitwork/>

 
      {/* Content-3 Section Start */}
      {contentdata.title3 && (
        <DataContent 
          title={contentdata.title3}
          desc={contentdata.description3}
          dnone={'Yes'}
        />
      )}

      {/* Content-3  Section End */}


      {/* Why Choose Us Section Start */}
      <WhyChoosedata/>
      {/* Why Choose Us Section End */}


       {/* Content-4 Section Start */}
      {contentdata.title4 && (
        <DataContent
          title={contentdata.title4}
          desc={contentdata.description4}
          dnone={'Yes'}
        />
      )}
      {/* Content-4 Section End */}


{/* Client Section Start */}
<Clientdata/>
{/* Client Section End */}



      {/* Content-5 Section Start */}

      {contentdata.title5 && (
        <DataContent
          title={contentdata.title5}
          desc={contentdata.description5}
        />
      )}

      {/* Content-5 Section End */}

      
      {/* Blog section Start */}
      
      <section className="blog_section_new section_padding_bottom">

    <div className="container">

        <div className="blog_heading_wrap">

            <span className="blog_sub_title">
                LATEST ARTICLES
            </span>

            <h2 className="blog_main_title">
                Our Latest Blogs
            </h2>

            <p className="blog_heading_text">
                Explore helpful guides, updates and information related to Gazette Services.
            </p>

        </div>

        <div className="row blog_row_space">

            {Blogs.map((value, index) => (
                <BlogHomebox
                    key={index}
                    slug={value.slug}
                    lang={value.lang}
                    image={value.sort_img}
                    image_title={value.image_title}
                    image_alt={value.image_alt}
                    date={value.date}
                    title={value.title}
                    tagline={value.tagline}
                />
            ))}

        </div>

    </div>

</section>

      {/* Blog section End */}
    </>
  );
}
